import {
  messageId,
  PropertyMeta,
  ValueObjectMetaNumber,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.number().min(0);
const savedMinimalSchema = z.number().min(0);
const schema = z.number().min(0);
const savedSchema = z.number().min(0);
const jsonSchema = z.number();
/**
 * 修正依頼ID(値オブジェクト)のメタデータ。
 *
 *  */
export const revisionRequestIdMeta = new ValueObjectMetaNumber(
  "RevisionRequestId",
  "\u4FEE\u6B63\u4F9D\u983CID",
  messageId("lbl.\u4FEE\u6B63\u4F9D\u983CID"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
